import Grid from './Grid'
import Keyboard from './Keyboard'

export default function Motus({ grid, keyboard, handleKeyPress, solution, statuses, currentRow, letterPosition, revealAnimationRow }) {

  return (
    <>
      <div className='grid' style={{ display: "flex", justifyContent: "center" }}>
          <Grid
              grid={grid}
              statuses={statuses}
              currentRow={currentRow}
              revealAnimationRow={revealAnimationRow}
              letterPosition={letterPosition}
          />
      </div>
      <div className='keyboard' style={{ display: "flex", justifyContent: "center" }}>
          <Keyboard keyboard={keyboard} onKeyPress={handleKeyPress} />
      </div>
    </>
  );
}